import { Link } from 'react-router-dom';
const NotFoundPage = (props) => {

  return (
    <div>
      404 Not found
      <Link to='/login'>
        <span>login</span>
      </Link>
    </div>
  );
}

export default NotFoundPage;
